<template>
  <div class="main">
    <Header
      :show="true"
      :title="showTitle"
    />
    <div>
      <div style="background-color: #0089ff; padding: 40px 20px">
        <van-row
          gutter="20"
          type="flex"
          align="center"
          justify="space-between"
          style="color: #ffffff"
        >
          <van-col span="16">
            <van-row style="font-size: 18px; margin: 0 0 10px">
              预约访问
            </van-row>
            <van-row style="font-size: 15px">
              在入厂前请先进行访问预约
            </van-row>
          </van-col>
          <van-col span="8">
            <el-button
              type="success"
              size="small"
              round
              @click="showNavButton = true"
            >
              <span style="font-size: 15px">免登录预约</span>
            </el-button>
            <el-button
              type="primary"
              size="small"
              round
              style="margin-top: 10px"
              @click="$router.replace({ path: '/dashboard/order', query: {} })"
            >
              <span style="font-size: 15px">登录账户</span>
            </el-button>
          </van-col>
        </van-row>
      </div>
      <van-cell-group>
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <div
                style="
                  width: 4px;
                  height: 2.2vh;
                  background-color: #ea7e2d;
                  border-radius: 0.6vw;
                  float: left;
                  margin-top: 2px;
                "
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
              >操作指引</span>
            </div>
          </template>
          <template #right-icon>
            <img
              src="@/assets/svg/iconCaoZuoBangZhu.svg"
              height="26px;"
              @click="handleClickHelp"
            >
          </template>
        </van-cell>
      </van-cell-group>

      <!-- <div style="height: 8px; background-color: #F8F8F8;" /> -->
      <van-notice-bar
        left-icon="volume-o"
        color="#1989fa"
        background="#ecf9ff"
        :text="guide"
      />
      <van-grid
        style="font-size: 0.36rem; color: #999999"
        :border="false"
        :center="false"
        :column-num="1"
      >
        <van-grid-item>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #ffffff;
              padding: 0 0;
            "
          >
            <img
              src="@/assets/dashboard/images/office-follow.jpg"
              height="260rem;"
              @click="handleClickPreviewFollow"
            >
          </div>
        </van-grid-item>
      </van-grid>
      <van-popup
        v-model="showNavButton"
        round
        style="width: 80%"
      >
        <div style="text-align: center">
          <div style="padding: 24px">
            <div
              style="font-size: 18px; font-weight: bold; margin-bottom: 12px"
            >
              立即预约
            </div>
            <div style="font-size: 14px">
              请选择您的访问方式
            </div>
          </div>
          <div
            style="display: flex"
            class="yuyue-btn-wrap"
          >
            <div style="flex: 1">
              <van-button
                block
                color="#58bd6a"
                plain
                hairline
                @click="$router.push('/dashboard/reserve/man')"
              >
                人员
              </van-button>
            </div>
            <div style="flex: 1">
              <van-button
                block
                color="#4187f2"
                plain
                hairline
                @click="$router.push('/dashboard/reserve/car')"
              >
                车辆
              </van-button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { Dialog, ImagePreview } from "vant";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";

export default {
  name: "DashboardOrder",
  components: {
    Header,
  },
  inject: ["reload"],
  data() {
    return {
      telphone: "0797-8181868",
      guide: "欢迎您光临永固万年青新型建材有限公司！",
      showNavButton: false,
    };
  },
  computed: {
    ...mapGetters({
      name: "user/name",
      userid: "user/userid",
    }),
    isLogin() {
      return !!this.userid;
    },
    showTitle() {
      return "访客";
    },
  },
  mounted() {
    if (this.isLogin) {
      this.$router.replace({ path: "/dashboard/order", query: {} });
    }
  },
  methods: {
    checkPermission,
    handleClickHelp() {
      Dialog.alert({
        title: "获取帮助",
        message: "如果您遇到什么问题，请联系：\n0797-8181868",
      }).then(() => {});
    },
    handleClickPreviewFollow() {
      ImagePreview({
        images: [
          require("@/assets/dashboard/images/office-follow.jpg"),
          require("@/assets/dashboard/images/aggregate-follow.jpg"),
          require("@/assets/dashboard/images/tank-follow.jpg"),
        ],
        closeable: true,
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
.van-cell {
  padding: 1.5vw 3vw;
}
::v-deep .van-grid-item__content {
  padding: 0 0;
}
::v-deep .van-dialog__message {
  padding: 20px 24px 12px;
  font-size: 0.36rem;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
.day-statistics {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
}
</style>
